module.exports = __webpack_public_path__ + "img/img2.258d4263.jpg";